























































































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import AppConsts from '@/lib/appconst';
import VueLazyload from 'vue-lazyload';
import ListMixin from '@/components/mixin/list-mixin';
import { mixins } from 'vue-class-component';
import _ from 'lodash';

class  PageRoomRequest extends PageRequest{
    keyword:string;
}

@Component
export default class Room extends mixins(ListMixin, AbpBase){
    namespace = 'room';
    spinShow = false;
     isTenant() {
      return this.$store.state.session.tenant != null;
    }
    get store () {
      return this.$store.state.room;
    }
    //filters
    pagerequest:PageRoomRequest=new PageRoomRequest();
    creationTime:Date[]=[];
    get list(){
      var re = this.store.list;
      var startIndex = (this.currentPage - 1) * this.pageSize;
      var index = 0;
      re.forEach(function(item) {
        item.orderNo = startIndex + index + 1;
        index++;
      });
      return re;
    }
    async removeRoom(id) {
      this.$Modal.confirm({
        title: this.L('Tips'),
        content: this.L(`Delete${_.startCase(this.namespace)}Confirm`),
        okText: this.L('Yes'),
        cancelText: this.L('No'),
        onOk: async () => {
          try
          {
              this.spinShow = true;
               await this.$store.dispatch({
              type: `${this.namespace}/delete`,
              data: { id: id}
          })
          await this.getpage();
          }
          catch
          {
            this.spinShow = false;
          }
         
        }
      })
    }
    columns= [
    {
        title:Util.L('Order'),
        key:'orderNo',
        width: 80,
    },{
        title:Util.L('Code'),
        width:200,
        key:'id'
    },{
        title:Util.L('Name'),
        width:200,
        key:'name'
    },{
        title:Util.L('CreatorUserName'),
        width:150,
        key:'creatorUserName'
    },{
        title:Util.L('CreationTime'),
        key:'creationTime',
        render:(h:any,params:any)=>{
            return h("span", Util.toViewDateString(params.row.creationTime));
        }
    },
    {
        title: this.L('Action'),
        slot: 'action',
        fixed: 'right',
        align: 'center',
        width: 200
    }]
    async created(){
      
    }
}
